import React, { Component } from "react";
import Swipe from 'react-swipe-component';
import ScrollableAnchor from 'react-scrollable-anchor'

import TimelineItems from "./TimelineItems"
import TimelineItemContainer from "./TimelineItemContainer"
import TimelineArrows from "./TimelineArrows"

import "./Timeline.scss"
import dataJSON from "../../api/Timeline.json"
class Timeline extends Component {
  constructor() {
    super();
    //dataJSON.list.reverse();
    this.state = {
      currItem: 0,
      itemWidth: (window.screen.width >= 768 ? (window.screen.width < 1100 ? 320 : 340) : 176),
      position: 0,
      lastItem: (window.screen.width >= 768 ? 290 : 176),
      timeline: {
        screen: (window.screen.width >= 768 ? 1000 : window.screen.width),
        width: (window.screen.width >= 768 ? 300 : 200)
      }
    }
    this.onSwipeLeftListener = this._onSwipeLeftListener.bind(this);
    this.onSwipeRightListener = this._onSwipeRightListener.bind(this);
    this.onSwipeDownListener = this._onSwipeUpListener.bind(this);
    this.onSwipeUpListener = this._onSwipeDownListener.bind(this);
    this.onSwipeListener = this._onSwipeListener.bind(this);
    this.isClicked = this.isClicked.bind(this);
    this.navigate = this.navigate.bind(this);
    this.showTimelineBar = this.showTimelineBar.bind(this);
  }
  componentDidMount() {
    var itemWidth = this.timeline.querySelector("li").offsetWidth;
    this.setState({
      timeline: {
        screen: (window.screen.width >= 768 ? 1000 : window.screen.width),
        width: itemWidth * (dataJSON.list.length)
      }
    })
    window.addEventListener("resize", () => {
      var itemWidth = this.timeline.querySelector("li").offsetWidth;
      this.setState({
        itemWidth: (window.screen.width >= 768 ? (window.screen.width < 1100 ? 320 : 340) : 176),
        lastItem: (window.screen.width >= 768 ? 290 : 176),
        timeline: {
          screen: (window.screen.width >= 768 ? 1000 : window.screen.width),
          width: itemWidth * (dataJSON.list.length)
        }
      })
    });
  }
  getRect(obj) {
    var rect = {
      top: obj.top + document.body.scrollTop,
      left: obj.left + document.body.scrollLeft
    }
    /*

      position: Math.round(item * (obj ? obj.offsetWidth : this.state.itemWidth) / 2)
      */
    return rect;
  }
  isClicked(item, obj) {
    var objWidth = (obj ? obj.offsetWidth : this.state.itemWidth);
    var jump = (item == 1 ? 0 : (this.state.timeline.screen - objWidth) - item * objWidth);

    if (item > this.state.currItem && item != 0) {
      window.dataLayer.push({
        'event': 'GA_Event',
        'Category': 'nespresso',
        'Action': 'Scroll_Timeline',
        'Label': "Left"
      });
    } else {
      window.dataLayer.push({
        'event': 'GA_Event',
        'Category': 'nespresso',
        'Action': 'Scroll_Timeline',
        'Label': "Right"
      });
    }

    this.setState({
      currItem: item,
      position: Math.round((jump < 0 ? jump * -1 : jump))
    });

    // window.dataLayer.push({
    //   'event': 'GA_Event',
    //   'Category': 'nespresso',
    //   'Action': 'Timeline_Clicked',
    //   'Label': dataJSON.list[item].name
    // });
  }
  navigate(item) {
    item = (item > dataJSON.list.length - 1 ? dataJSON.list.length - 1 : item);
    item = (item < 0 ? 0 : item);
    this.isClicked(item, null);
  }
  initTimeline() {
    return dataJSON.list.map((item, index) =>
      <TimelineItems key={index} index={index}
        currItem={this.state.currItem}
        isClicked={this.isClicked}
        item={item} />
    )
  }
  initTimelineContainers() {
    /*
    <TimelineItemContainer item={dataJSON.list[this.state.currItem]} />
    */
    return dataJSON.list.map((item, index) =>
      <TimelineItemContainer key={index} index={index}
        currItem={this.state.currItem}
        isClicked={this.isClicked}
        item={item} />
    )
  }
  _onSwipeLeftListener() {
    this.navigate(this.state.currItem - 1);
  }
  _onSwipeRightListener() {
    this.navigate(this.state.currItem + 1);
  }
  _onSwipeUpListener() { }
  _onSwipeDownListener() { }
  _onSwipeListener(e) {
    /*
       if (e[1] === 0) console.log("Swipe x: " + e[0]);
      else if (e[0] === 0) console.log("Swipe y: " + e[1]);
                  <li className="bgleft" ref={(lastItem) => { this.lastItem = lastItem }} style={{ width: this.state.lastItem }}></li>
    */
  }
  isMobileScreen() {
    return (window.screen.width < 1000 ? Math.ceil(Math.round(0.70 * Math.max(document.documentElement.clientWidth, window.innerWidth || 0))) : 1000);
  }
  showTimelineBar() {
    return (<div className="list">
      <Swipe
        nodeName="div"
        className="list-wrapper"
        mouseSwipe={false}
        onSwipedLeft={this.onSwipeLeftListener}
        onSwipedRight={this.onSwipeRightListener}
        onSwipedDown={this.onSwipeDownListener}
        onSwipedUp={this.onSwipeUpListener}
        onSwipe={this.onSwipeListener}>
        <ul ref={(timeline) => { this.timeline = timeline }} style={{ width: this.state.timeline.width, transform: (this.state.currItem > 0 ? `translateX(${Math.round(this.state.position)}px)` : "") }}>
          {this.initTimeline()}
        </ul>
      </Swipe>
    </div>)
  }
  render() {
    return (
      <ScrollableAnchor id="timeline">
      <section className="section section-timeline">
        <div className="flowers">
          <div className="left"></div>
        </div>
        <div className="padding">
          <div className="container">
            <div className="headline">
              <h3 dangerouslySetInnerHTML={{__html: dataJSON.text}}></h3>
            </div>
            {(window.screen.width < 1000 ? this.showTimelineBar() : "")}
            <div className="items-container">
              <div className="items-wrapper" style={{ width: (window.screen.width >= 1000 ? 1000 : this.isMobileScreen()) * (dataJSON.list.length + 1), transform: (this.state.currItem > 0 ? `translateX(${Math.round((window.screen.width >= 1000 ? 1000 : this.isMobileScreen()) * this.state.currItem)}px)` : "") }}>
                {this.initTimelineContainers()}
              </div>
            </div>
            {(window.screen.width >= 1000 ? this.showTimelineBar() : "")}
            <TimelineArrows currItem={this.state.currItem} navigate={this.navigate} />
          </div>
        </div>
      </section>
      </ScrollableAnchor>
    );
  }
}

export default Timeline;



// WEBPACK FOOTER //
// ./src/Components/Timeline/Timeline.js